import Joi from "joi";

export const outletTypeFormSchema = Joi.object({
  id: Joi.string().allow(""),
  name: Joi.string().required().messages({
    "string.empty": "Name should not be empty",
  }),
  description: Joi.string().allow(""),
}).unknown();
